export default __webpack_public_path__ + "1f8faab481e54cdefd58a83c407d39a9.png";